import { React, useState } from 'react';
import { useUserContext } from 'contexts/UserContext';
import { Card, Form, Stack, Button } from 'react-bootstrap';
import * as api from 'services/api';
import { useTranslation } from 'react-i18next';
export function Account() {
    const { t } = useTranslation();
    const { userData, updateUser } = useUserContext();
  const [formData, setFormData] = useState({
    name: userData.name,
    surnames: userData.surnames,
    username: userData.username,
    phone: userData.phone
  });
 
  const [error, setError] = useState('');

    
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, surnames, username, phone } = formData;

    const updatedUserData = {
      ...userData,
      name,
      surnames,
      username,
      phone,
      password: ''
    };
    
    const response = await api.updateUserAccount(updatedUserData);
    if (response.status === 200) {
      updateUser(updatedUserData);
    } else {
      setError(response.data.message);
    }
  };

  return (
    <Card className="UserProfile mt-4 p-4">
          <Card.Title className='mb-3'>{t('prEdit')}</Card.Title>
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3" controlId="name">
          <Form.Label className="small text-start">{t('usName')}</Form.Label>
          <Form.Control
            type="text"
            className="form-control bg-light"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="surnames">
          <Form.Label className="small text-start">{t('usSurnames')}</Form.Label>
          <Form.Control
            type="text"
            className="form-control bg-light"
            name="surnames"
            value={formData.surnames}
            onChange={handleInputChange}
          />
        </Form.Group>

        <Form.Group className="mb-3" controlId="username">
          <Form.Label className="small text-start">{t('username')}</Form.Label>
          <Form.Control
            type="text"
            className="form-control bg-light"
            name="username"
            value={formData.username}
            onChange={handleInputChange}
          />
        </Form.Group>
        <Form.Group className="mb-3" controlId="username">
            <Form.Label className="small text-start">{t('phone')}</Form.Label>
            <Form.Control
                type="text"
                className="form-control bg-light"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
            />
        </Form.Group>
        <Stack direction="horizontal" className="justify-content-start">
          {error && <p className="text-danger fw-semibold">{error}</p>}
        </Stack>
        <Button variant="dark" className="mt-3" type="submit">
                  {t('prSave') }
        </Button>
      </Form>
    </Card>
  );
}
